import { render, staticRenderFns } from "./_root.vue?vue&type=template&id=6577f5d5&scoped=true&"
import script from "./_root.vue?vue&type=script&lang=js&"
export * from "./_root.vue?vue&type=script&lang=js&"
import style0 from "./_root.vue?vue&type=style&index=0&id=6577f5d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6577f5d5",
  null
  
)

export default component.exports